import type { QueryClient } from '@tanstack/react-query';

import type { NewPersona, Persona } from '../../../domain/persona';
import type { AppStore } from '../../../services/appStore';
import { translate } from '../../../services/i18n';
import { personaApi } from '../api';
import { PERSONAS_QUERY_KEY } from '../personasQuery/personasQueryKey';

import type { CreatePersonaRepository } from './useCase';

export const makeCreatePersonaRepository = (appStore: AppStore, queryClient: QueryClient): CreatePersonaRepository => ({
  createPersona: (persona: NewPersona) => personaApi.createPersona(persona),
  addPersona: (persona: Persona) => {
    queryClient.setQueryData(PERSONAS_QUERY_KEY, (oldData: Persona[] | undefined) => {
      if (!oldData) {
        return [persona];
      }

      return [...oldData, persona];
    });
    appStore.setContactsPersona(persona);
  },
  notifyPersonaCreated: (persona: Persona) => {
    appStore.setSuccessToast({
      content: translate('contacts.persona.created', { personaName: persona.name }),
    });
  },
});
